// Файл page_load_mobile_version_history.js
/**
 * Модуль показывает историю мобильных выпусков приложения.
 * Он разбивает записи изменений на порции для показа.
 * Код использует существующие компоненты и зависимости этого раздела.
 * Его функции участвуют в работе соответствующей страницы или сервиса.
 */


import { useState } from 'react';



const HISTORY_BATCH_SIZE = 50;


const ChangelogItem = ({ row }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="changelog-item">
            <div
                className="changelog-header"
                onClick={() => setOpen(!open)}
            >
                <div className="changelog-info">
                    <span className="date">
                        Дата выхода: {row['Release date']}
                    </span>
                    <span className="version">
                        Версия ПО: {row['Version_number']}
                    </span>
                </div>
                <button
                    className="toggle-btn"
                    type="button"
                >
                    {open ? '-' : '+'}
                </button>
            </div>

            <div
                className="changelog-details"
                style={{ display: open ? 'block' : 'none' }}
            >
                {row['Что доработали:'] && (
                    <div className="improvements">
                        <strong>Улучшения:</strong>
                        <ul>
                            {String(row['Что доработали:'])
                                .split('\n')
                                .filter(Boolean)
                                .map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))
                            }
                        </ul>
                    </div>
                )}
                {row['Что исправили:'] && (
                    <div className="fixes">
                        <strong>Исправления:</strong>
                        <ul>
                            {String(row['Что исправили:'])
                                .split('\n')
                                .filter(Boolean)
                                .map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))
                            }
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};


export { ChangelogItem, HISTORY_BATCH_SIZE };
